import { createTheme } from 'thememirror';
import { tags as t } from '@lezer/highlight';

const sharedStyles = [
  {
    tag: t.heading,
    fontWeight: 'bold',
    color: 'var(--md-sys-color-primary)',
  },
  {
    tag: t.strong,
    fontWeight: 'bold',
    color: 'var(--md-sys-color-primary)',
  },
  {
    tag: t.emphasis,
    fontStyle: 'italic',
    color: 'var(--md-sys-color-primary)',
  },
  {
    tag: t.link,
    textDecoration: 'underline',
    color: 'var(--md-sys-color-primary)',
  },
  {
    tag: t.monospace,
    class: 'md-code',
  },
  {
    tag: t.quote,
    class: 'md-quote',
  },
  {
    tag: t.list,
    class: 'md-list',
  },
  {
    tag: t.contentSeparator,
    color: 'var(--md-sys-color-primary)',
  },
  {
    tag: t.url,
    color: 'var(--md-extended-color-success, var(--md-sys-color-tertiary))',
  },
];

export const customEditorDarkTheme = createTheme({
  variant: 'dark',
  settings: {
    background: '#1a1c20',
    foreground: '#AADAFA',
    caret: '#7c3aed',
    selection: '#304e75',
    lineHighlight: '#8a91991a',
    gutterBackground: '#1d2024',
    gutterForeground: '#6b717b',
  },
  styles: [
    {
      tag: t.comment,
      color: '#73985d',
    },
    {
      tag: t.variableName,
      color: '#6fbff9',
    },
    {
      tag: [t.string, t.special(t.brace)],
      color: '#c6947c',
    },
    {
      tag: t.number,
      color: '#bbcdab',
    },
    {
      tag: t.bool,
      color: '#679ad1',
    },
    {
      tag: t.null,
      color: '#70c6b1',
    },
    {
      tag: t.keyword,
      color: '#679ad1',
    },
    {
      tag: t.operator,
      color: '#d4d4d4',
    },
    {
      tag: t.className,
      color: '#70c6b1',
    },
    {
      tag: t.definition(t.typeName),
      color: '#70c6b1',
    },
    {
      tag: t.typeName,
      color: '#70c6b1',
    },
    {
      tag: t.angleBracket,
      color: '#808080',
    },
    {
      tag: t.tagName,
      color: '#679ad1',
    },
    {
      tag: t.attributeName,
      color: '#aadafa',
    },
    ...sharedStyles,
  ],
});

export const customEditorLightTheme = createTheme({
  variant: 'light',
  settings: {
    background: '#fcfcfc',
    foreground: '#5c6166',
    caret: '#ffaa33',
    selection: '#036dd626',
    gutterBackground: '#fcfcfc',
    gutterForeground: '#8a919966',
    lineHighlight: '#8a91991a',
  },
  styles: [
    {
      tag: t.comment,
      color: '#787b8099',
    },
    {
      tag: t.string,
      color: '#306dae',
    },
    {
      tag: t.regexp,
      color: '#4cbf99',
    },
    {
      tag: [t.number, t.bool, t.null],
      color: '#ffaa33',
    },
    {
      tag: t.variableName,
      color: '#5c6166',
    },
    {
      tag: [t.definitionKeyword, t.modifier],
      color: '#fa8d3e',
    },
    {
      tag: [t.keyword, t.special(t.brace)],
      color: '#fa8d3e',
    },
    {
      tag: t.operator,
      color: '#ed9366',
    },
    {
      tag: t.separator,
      color: '#5c6166b3',
    },
    {
      tag: t.punctuation,
      color: '#5c6166',
    },
    {
      tag: [t.definition(t.propertyName), t.function(t.variableName)],
      color: '#f2ae49',
    },
    {
      tag: [t.className, t.definition(t.typeName)],
      color: '#22a4e6',
    },
    {
      tag: [t.tagName, t.typeName, t.self, t.labelName],
      color: '#55b4d4',
    },
    {
      tag: t.angleBracket,
      color: '#55b4d480',
    },
    {
      tag: t.attributeName,
      color: '#f2ae49',
    },
    ...sharedStyles,
  ],
});
